<template>
  <v-dialog
    v-model="isOpened"
    persistent
    width="640px"
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar color="primary darken-1" dark>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="isOpened = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-toolbar color="deep-purple lighten-5" dense class="pa-0 font-weight-medium">
        {{ user.firstname }} {{ user.lastname }}
      </v-toolbar>
      <v-card-text class="pa-4">
        <h3 class="mb-2 pt-2">Quelle va être l'effet de cette règle ?</h3>
        <v-radio-group
          v-model="isNegative"
          hide-details
          class="d-flex"
        >
          <v-row no-gutters>
            <v-col>
              <v-radio
                :value="false"
                label="Être notifié"
                color="primary darken-1"
              ></v-radio>
            </v-col>
            <v-col>
              <v-radio
                :value="true"
                label="Ne pas être notifié"
                color="primary darken-1"
              >
              </v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
        <v-divider class="my-5" />
        <v-form class="mt-4 rule-options">
          <v-row no-gutters align="center" justify="center" class="mt-2">
            <v-col cols="4" class="text-right pr-3">
              <b>Type d'événement</b>
            </v-col>
            <v-col>
              <v-select
                v-model="type"
                :items="types"
                multiple
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                class="main-option enabled"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2">
            <v-col cols="4" class="text-right pr-3">
              <b>Origine</b>
            </v-col>
            <v-col>
              <v-select
                v-model="origin"
                :items="origins"
                multiple
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                class="origin enabled"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2" v-if="isRootUser || isSelfMakerUser">
            <v-col cols="4" class="text-right pr-3">
              <b>Si l'utilisateur est assigné</b>
            </v-col>
            <v-col>
              <v-select
                v-model="isAssigned"
                :items="isAssignedList"
                item-text="name"
                item-value="value"
                single-line
                hide-details
                outlined
                class="is-assigned"
                :class="{ enabled: isAssigned }"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2" v-if="isAggregatorUser">
            <v-col cols="4" class="text-right pr-3">
              <b>Pour le site</b>
            </v-col>
            <v-col>
              <v-select
                v-model="site"
                :items="sites"
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                class="site"
                :class="{ enabled: site && site.id }"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2" v-if="isRootUser">
            <v-col cols="4" class="text-right pr-3">
              <b>Pour le client</b>
            </v-col>
            <v-col>
              <v-select
                v-model="$client"
                :items="clients"
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                @change="$forceUpdate()"
                class="client"
                :class="{ enabled: $client && $client.id }"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2" v-if="isAggregatorUser">
            <v-col cols="4" class="text-right pr-3">
              <b>Pour le prestataire</b>
            </v-col>
            <v-col>
              <v-select
                v-model="maker"
                :items="makers"
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                class="maker"
                :class="{ enabled: maker && maker.id }"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2">
            <v-col cols="4" class="text-right pr-3">
              <b>Avec le domaine</b>
            </v-col>
            <v-col>
              <v-select
                v-model="domain"
                :items="domains"
                :disabled="!maker || !maker.id"
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                class="domain"
                :class="{ enabled: domain && domain.id }"
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters align="center" justify="center" class="mt-2">
            <v-col cols="4" class="text-right pr-3">
              <b>Avec la priorité</b>
            </v-col>
            <v-col>
              <v-select
                v-model="priority"
                :items="priorities"
                :disabled="!maker || !maker.id"
                item-text="name"
                item-value="id"
                single-line
                return-object
                hide-details
                outlined
                class="priority"
                :class="{ enabled: priority && priority.id }"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pl-4 pr-4">
        <v-spacer></v-spacer>
        <v-btn text @click="isOpened = false">Annuler</v-btn>
        <v-btn color="primary darken-1" @click="submit()">
          {{ isUpdating ? `Modifier` : `Ajouter` }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: `NotificationRuleDialog`,
  props: {
    value: {},
    rule: {},
    client: {},
  },
  data: () => ({
    type: null,
    origin: null,
    $client: null,
    maker: null,
    site: null,
    domain: null,
    priority: null,
    isAssigned: false,
    isNegative: false,
    isRootUser: false,
    isSelfMakerUser: false,
    isAggregatorUser: false,
    isAssignedList: [
      { name: `-- Peu importe --`, value: false },
      { name: `Oui, que dans ce cas`, value: true },
    ],
    defaultIsAssigned: false,
    defaultIsNegative: false,
    defaultSite: { id: null, name: `-- Peu importe --` },
    defaultDomain: { id: null, name: `-- Peu importe --` },
    defaultPriority: { id: null, name: `-- Peu importe --` },
    storeSites: [],
    types: [
      { id: 1, name: `Créée` },
      { id: 2, name: `Commentée` },
      { id: 4, name: `Nouvelle PJ` },
      { id: 8, name: `Clôturée` },
    ],
    origins: [
      { id: 1, name: `Interne` },
      { id: 2, name: `Externe` },
    ],
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) {
        this.$emit(`input`, isOpened);
      },
    },
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`model/user`, {
      user: `currentUser`,
    }),
    ...mapState(`model/maker`, {
      makers(state) {
        return [
          this.defaultMaker,
          ...state.currentUserMakers,
        ];
      },
    }),
    ...mapState(`model/client`, {
      clients(state) {
        return [
          this.defaultClient,
          ...state.clients,
        ];
      },
    }),
    sites() {
      return [
        this.defaultSite,
        ..._.chain(this.storeSites)
          .map(site => ({
            ...site,
            $name: _.toLower(site.name),
          }))
          .sortBy(`$name`)
          .value(),
      ];
    },
    ...mapState(`model/priority`, {
      priorities(state) {
        let makerPriorities = [];
        if (state.makerPriorities.length && this.maker && state.makerPriorities[0].Maker_id === this.maker.id) {
          makerPriorities = state.makerPriorities; // eslint-disable-line
        }

        return [
          this.defaultPriority,
          ...makerPriorities,
        ];
      },
    }),
    ...mapState(`model/domain`, {
      domains(state) {
        let makerDomains = [];
        if (state.makerDomains.length && this.maker && state.makerDomains[0].Maker_id === this.maker.id) {
          makerDomains = state.makerDomains; // eslint-disable-line
        }

        return [
          this.defaultDomain,
          ...makerDomains,
        ];
      },
    }),
    defaultType() {
      return this.types;
    },
    defaultOrigin() {
      return this.origins;
    },
    realClient() {
      if (!this.company.isRoot) {
        return this.company;
      }
      return this.client;
    },
    defaultClient() {
      if (!this.isRootUser && !this.isAggregatorUser) {
        return this.realClient;
      }
      if (!this.isRootUser) {
        return this.company;
      }

      return { id: null, name: `-- Peu importe --` };
    },
    defaultMaker() {
      if (this.company.isRoot) {
        return this.company;
      }
      if (this.realClient.isRoot) {
        return this.realClient;
      }
      if (this.client.isRoot) {
        return this.client;
      }
      return { id: null, name: `-- Peu importe --` };
    },
    isUpdating() {
      return this.rule && this.rule.id;
    },
    title() {
      return this.isUpdating ? `Modifier une règle de notification` : `Ajouter une règle de notification`;
    },
  },
  methods: {
    async fetchSites() {
      if (this.$client && this.$client.id) {
        this.storeSites = await this.$store.dispatch(`model/site/fetchSitesForClient`, this.$client.id);
      } else {
        this.storeSites = [];
      }
    },
    async submit() {
      const isNegative = this.isNegative === true;
      if (isNegative) {
        this.type = [{ id: 0 }];
        this.origin = [{ id: 0 }];
      }

      if (!this.type.length) { return; }
      if (!this.origin.length) { return; }

      const rule = {
        user: this.user,
        client: this.company.isRoot ? this.$client : this.company,
        site: this.$client && this.site && this.site.id ? this.site : null,
        maker: !this.realClient.isRoot ? this.maker : this.company,
        priority: this.priority && this.priority.id ? this.priority : null,
        domain: this.domain && this.domain.id ? this.domain : null,
        type: _.sumBy(this.type, `id`),
        origin: _.sumBy(this.origin, `id`),
        isAssigned: (!this.realClient.isRoot && !this.realClient.isSelfMaker) ? false : this.isAssigned === true,
        isNegative,
      };
      await this.$store.dispatch(this.isUpdating ? `model/notificationRule/updateNotificationRule` : `model/notificationRule/addNotificationRule`, rule);
      this.isOpened = false;
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.isRootUser = this.client.isRoot && this.company.id === this.client.id;
        this.isSelfMakerUser = this.realClient.isSelfMaker;
        this.isAggregatorUser = !this.isRootUser && this.client.slug && this.client.slug !== ``;
        this.type = this.isUpdating ? this.rule.type : this.defaultType;
        this.origin = this.isUpdating ? this.rule.origin : this.defaultOrigin;
        this.isAssigned = this.isUpdating ? this.rule.isAssigned : this.defaultIsAssigned;
        this.isNegative = this.isUpdating ? this.rule.isNegative : this.defaultIsNegative;
        this.$client = this.isUpdating ? this.rule.client : this.defaultClient;
        this.site = this.isUpdating ? this.rule.site : this.defaultSite;
        this.maker = this.isUpdating ? this.rule.maker : this.defaultMaker;
        this.domain = this.isUpdating ? this.rule.domain : this.defaultDomain;
        this.priority = this.isUpdating ? this.rule.priority : this.defaultPriority;
        if (this.isRootUser) {
          this.$store.dispatch(`model/client/fetchClients`, this.realClient.id);
        } else if (this.isAggregatorUser) {
          this.$store.dispatch(`model/maker/fetchCurrentUserMakers`);
        }
        this.fetchSites();
      }
    },
    maker(maker) {
      if (maker && maker.id) {
        this.$store.dispatch(`model/priority/fetchMakerPriorities`, maker.id);
        this.$store.dispatch(`model/domain/fetchMakerDomains`, maker.id);
      }
      this.domain = this.defaultDomain;
      this.priority = this.defaultPriority;
    },
    client() {
      this.fetchSites();
    },
  },
};
</script>

<style lang="scss">
  .rule-options {
    .main-option {
      border-color: #673ab7;
    }
    .origin {
      border-color: #f40404;
    }
    .is-assigned.enabled {
      border-color: #FF9800;
    }
    .client.enabled,
    .maker.enabled {
      border-color: #05A9F4;
    }
    .site.enabled {
      border-color: #fa8f01;
    }
    .domain.enabled {
      border-color: #388E3C;
    }
    .priority.enabled {
      border-color: #E91E63;
    }
    .v-select {
      .v-input__control,
      .v-input__slot,
      fieldset {
        border-color: inherit;
        border-width: 1px;
      }
    }
    .v-select.enabled {
      .v-input__control,
      .v-input__slot,
      fieldset {
        border-width: 3px;
      }
    }
  }
</style>
